import {TelefoneSuper} from './telefone-super';
import {Telefone} from './telefone';
import {Construtor} from './construtor';

export class TelefoneUsuario extends TelefoneSuper implements Construtor<TelefoneUsuario> {

  public idTelefoneUsuario: number;

  public idUsuario: number;

  public alterado: boolean;

  constructor(object?: any) {
    super();
    this.telefone = new Telefone();
    if (object !== undefined) {

      if (object instanceof TelefoneUsuario) {
        this.copyObject(object);
      } else if (object instanceof Telefone) {
        this.telefone = object;

      } else {
        this.parseFromJson(object);
      }
    }

    return this;
  }

  get obterIdTelefoneUsuario(): number {
    return this.idTelefoneUsuario;
  }

  set IdTelefoneUsuario(idTelefoneUsuario: any) {
    this.idTelefoneUsuario = idTelefoneUsuario;
  }

  get obterIdUsuario(): number {
    return this.idUsuario;
  }

  set IdUsuario(idUsuario: any) {
    this.idTelefoneUsuario = idUsuario;
  }

  copyObject(telefoneUsuario: TelefoneUsuario): void {
    this.idTelefoneUsuario = telefoneUsuario.obterIdTelefoneUsuario;
    this.idUsuario = telefoneUsuario.obterIdUsuario;
    this.Telefone = telefoneUsuario.telefone;
  }

  parseFromJson(telefoneUsuario: any): void {
    this.IdTelefoneUsuario = telefoneUsuario.idTelefoneUsuario;
    this.IdUsuario = telefoneUsuario.idUsuario;
    this.Telefone = telefoneUsuario.telefone;
  }

  getNewInstance(object?: any): TelefoneUsuario {
    return new TelefoneUsuario(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/telefone-usuario.ts